module.exports = __webpack_public_path__ + "media/music/piano_chords_2-afacca06.mp3";